import cn from 'classnames';
import React from 'react';

interface TitleProps {
  align?: 'left' | 'center' | 'right';
}

const Title: React.FC<React.PropsWithChildren<TitleProps>> = ({
  children,
  align = 'center',
}) => {
  return (
    <h3
      className={cn(
        'mindset-24 lg:mindset-40 text-text-primary pb-6 md:pb-12',
        align === 'left' && 'text-left',
        align === 'center' && 'text-center',
        align === 'right' && 'text-right'
      )}
    >
      {children}
    </h3>
  );
};

export default Title;
